import * as React from "react";

interface Props {
    onCloseDialog: () => any;
    className?: string;
}

interface State {}

const s = require("./Dialog.scss");

export default class Dialog extends React.Component<Props, State> {
    render(): JSX.Element {
        return (
            <div className={s.overall} onClick={this.props.onCloseDialog}>
                <div className={s.dialog + " " + (this.props.className || "")} onClick={ev => ev.stopPropagation()}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Dialogs/Dialog/index.tsx